import { useEffect } from 'react';
import useToast from 'components/hooks/useToast';
import _ from 'lodash';
import { FULL_REPO_PATH } from './usePaths';

const FOLDER_PATH_PATTERN =
  '^([a-z0-9-_.]+)([/\\\\][a-z0-9-_.]+)*([a-z0-9-_.])*$';

const UI_SELECTORS = {
  SERVICE_NAME_INPUT: '[data-cy="input-service-name"]',
  REPOSITORIES_AUTOCOMPLETE_TOGGLER:
    '[data-cy="repositories-autocomplete"] .MuiAutocomplete-popupIndicator',
  PATH_INPUT: '[data-cy="input-path"]'
};

const useServiceFormValidation = ({ serviceName, selectedRepo, paths }) => {
  const toast = useToast();

  const refs = {
    serviceNameInput: document.querySelector(UI_SELECTORS.SERVICE_NAME_INPUT),
    reposAutocomplete: document.querySelector(
      UI_SELECTORS.REPOSITORIES_AUTOCOMPLETE_TOGGLER
    ),
    pathInput: document.querySelector(UI_SELECTORS.PATH_INPUT)
  };
  const selectedRepoName = _.get(selectedRepo, 'name');

  const getRepoPathsByRepoId = repoId =>
    paths.find(({ repository_id }) => repository_id === repoId);

  const parsePath = value => {
    let parsedValue = value.trim();
    if (parsedValue === FULL_REPO_PATH) return parsedValue;

    parsedValue = parsedValue.toLowerCase();
    parsedValue = parsedValue.replace(/\\/g, '/');
    if (parsedValue.slice(0, 1) === '/')
      //strats with /
      parsedValue = parsedValue.slice(1);
    if (parsedValue.slice(-1) === '/')
      //ends with /
      parsedValue = parsedValue.slice(0, -1);
    return parsedValue;
  };

  const validatePath = (value, repoId) => {
    const currRepo = getRepoPathsByRepoId(repoId);
    const currRepoPaths = _.get(currRepo, 'paths', []);

    const pathPattern = new RegExp(FOLDER_PATH_PATTERN);

    if (!selectedRepo) {
      toast({ message: 'Please select a repository', variant: 'error' });
      return refs.reposAutocomplete?.click();
    }
    if (
      value.length === 0 ||
      (!pathPattern.test(value) && value !== FULL_REPO_PATH)
    ) {
      toast({
        message:
          'Please enter a valid path. Special characters are not allowed',
        variant: 'error'
      });
      return refs.pathInput?.focus();
    }
    if (currRepoPaths.includes(value)) {
      toast({
        message: 'Path value already exists in this repository',
        variant: 'error'
      });
      return refs.pathInput?.focus();
    }
    return true;
  };

  const validateForm = () => {
    if (serviceName.length < 2) {
      toast({ message: 'Please enter a valid service name', variant: 'error' });
      return refs.serviceNameInput?.focus();
    }
    if (_.size(paths) === 0) {
      toast({
        message: 'Please choose at least one repository/path',
        variant: 'error'
      });
      return !selectedRepo
        ? refs.reposAutocomplete?.click()
        : refs.pathInput?.focus();
    }
    return true;
  };

  useEffect(() => {
    //auto focus pathsInput onChange:repository
    if (selectedRepoName) refs.pathInput?.focus();
  }, [selectedRepoName]);

  return {
    validateForm,
    validatePath,
    parsePath
  };
};

export default useServiceFormValidation;
